import { VideoStandardDefinitionIcon } from './VideoStandardDefinitionIcon';

/**
 * author: Michael Richins
 * id EAEE3AC5-7C61-4513-9AB1-692E20E99F9E
 * name video-standard-definition
 * version: 7.3.67
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/video-standard-definition.svg
 * tags
 * - Video / Movie 
 */
export const VideoSdIcon = VideoStandardDefinitionIcon;
export default VideoSdIcon